export const NAME = 'organization_events'
export const ITEMS_PER_PAGE = 8
